import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { UltimateBeneficialOwnershipRequest } from 'projects/reg-hub-common/src/public-api';
import { PatchDocument } from '../../interfaces/patch-document';

@Injectable({
  providedIn: 'root'
})
export class UltimateBeneficialOwnershipRequestService {
  protected _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
    private http: HttpClient,
  ) {
    this._baseLink = `${this.config.rootUrl}/Orders`;
  }

  public businessReportHasUltimateBeneficialOwnershipRequest(businessReportID: string): Observable<{ exists: boolean }> {
    return this.http.get<{exists: boolean}>(`${this._baseLink}/${businessReportID}/UltimateBeneficialOwnershipRequest/Exists`);
  }

  public patchUltimateBeneficialOwnershipRequest = (orderID: string, uboRequestId: string, patch: PatchDocument[]) => {
    return this.http.patch<UltimateBeneficialOwnershipRequest>(`${this._baseLink}/${orderID}/UltimateBeneficialOwnershipRequest/${uboRequestId}`, patch);
  };
}
